/** Chrome reduziu o UA — SM-X210 deixa de aparecer; usar Client Hints + ecrã. */

function hasTouch() {
  return navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
}

function tabletFromClientHintsLowEntropy() {
  const uaData = navigator.userAgentData;
  if (!uaData?.platform) return false;
  const platform = uaData.platform.toLowerCase();
  if (platform === 'android' && uaData.mobile === false) return true;
  if (platform === 'ios' && uaData.mobile === false) return true;
  return false;
}

function tabletFromLegacyUa(ua) {
  if (/SM-[XTP]\d{3}|Galaxy Tab|Tab A/i.test(ua)) return true;
  if (/iPad|Tablet|PlayBook|Silk/i.test(ua)) return true;
  if (hasTouch() && /Android/i.test(ua) && !/Mobile/i.test(ua)) return true;
  return false;
}

function tabletFromScreen() {
  if (!hasTouch()) return false;
  const sizes = [
    window.innerWidth,
    window.innerHeight,
    window.screen?.width,
    window.screen?.height,
  ].filter((n) => typeof n === 'number' && n > 0);
  if (sizes.length < 2) return false;
  const min = Math.min(...sizes);
  const max = Math.max(...sizes);
  return min >= 600 && max >= 900 && max <= 2400;
}

function tabletFromOverride() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('tablet') === '1') {
      localStorage.setItem('games-tom-tablet', '1');
      return true;
    }
    if (params.get('tablet') === '0') {
      localStorage.removeItem('games-tom-tablet');
      return false;
    }
    if (localStorage.getItem('games-tom-tablet') === '1') return true;
  } catch {
    /* ignore */
  }
  return false;
}

export function isTabletDevice() {
  if (tabletFromOverride()) return true;

  const ua = navigator.userAgent || '';
  if (tabletFromClientHintsLowEntropy()) return true;
  if (tabletFromLegacyUa(ua)) return true;
  if (tabletFromScreen()) return true;
  return false;
}

async function enrichTabletFromHighEntropyHints() {
  const uaData = navigator.userAgentData;
  if (!uaData?.getHighEntropyValues) return false;
  try {
    const hints = await uaData.getHighEntropyValues(['model', 'formFactors', 'platform']);
    if (/^SM-[XTP]/i.test(hints.model || '')) return true;
    if (Array.isArray(hints.formFactors) && hints.formFactors.includes('Tablet')) return true;
    if (String(hints.platform).toLowerCase() === 'android' && uaData.mobile === false) return true;
  } catch {
    /* permission denied or unsupported */
  }
  return false;
}

export function applyDeviceLayoutClasses() {
  const html = document.documentElement;
  const tablet = isTabletDevice();
  const landscape = window.innerWidth > window.innerHeight;

  html.classList.toggle('is-tablet', tablet);
  if (tablet) {
    html.classList.toggle('layout-landscape', landscape);
    html.classList.toggle('layout-portrait', !landscape);
  } else {
    html.classList.remove('layout-landscape', 'layout-portrait');
  }
}

export function initDeviceLayout() {
  applyDeviceLayoutClasses();

  enrichTabletFromHighEntropyHints().then((tablet) => {
    if (!tablet || document.documentElement.classList.contains('is-tablet')) return;
    applyDeviceLayoutClasses();
  });

  window.addEventListener('resize', applyDeviceLayoutClasses, { passive: true });
  window.addEventListener('orientationchange', () => {
    window.setTimeout(applyDeviceLayoutClasses, 150);
  });
}
